import {Component, Input} from 'ng-metadata/core';



import { VirtualBrowseItemInfoService, ItemInfo} from './virtualBrowseItemInfo.service';
//your imports go here
import {VirtualBrowseItem} from '../virtualBrowse.service';


@Component({
selector: 'prm-virtual-browse-item-info',
templateUrl: 'components/search/virtualBrowse/virtualBrowseItemInfo/virtual-browse-item-info.html',
})


export class PrmVirtualBrowseItemInfo{
    @Input() private virtualBrowseItem: VirtualBrowseItem;
    private itemInfo: ItemInfo;
    constructor(private virtualBrowseItemInfoService: VirtualBrowseItemInfoService) {
    }

    ngOnInit(){
//        this.virtualBrowseItemInfoService.getItem(this.virtualBrowseItem.recordId).then((response)=>{
//            this.itemInfo= response});
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/virtualBrowse/virtualBrowseItemInfo/virtualBrowseItemInfo.directive.ts